var map = {
	"./features/app/data.flower.server.json": 72985,
	"./pages/Cart/cartOrder.flower.server.json": 70441,
	"./pages/OrderDetail/orderDetail.flower.server.json": 43477,
	"./pages/Orders/orders.flower.server.json": 68381,
	"./pages/Orders/productQuantity.flower.server.json": 25446,
	"./pages/Orders/productStatus.flower.server.json": 64085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96224;